import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { PV } from '@/constants/testIds';
import { Check, X } from 'lucide-react';
import SectionActions from './SectionActions';

export const Comparison = ({ compact = false }) => {
  const { t } = useLanguage();

  return (
    <section
      id="why"
      data-testid={PV.comparisonSection}
      className="relative bg-white py-20 md:py-28 border-t border-slate-100"
    >
      <div className="pv-container">
        {!compact && (
          <div className="max-w-2xl">
            <span className="text-[11px] md:text-[12px] font-semibold uppercase tracking-[0.18em] text-slate-500">
              {t.comparison.eyebrow}
            </span>
            <h2 className="mt-4 font-heading font-bold tracking-normal text-[32px] sm:text-[40px] md:text-[48px] leading-[1.08] text-pv-ink">
              {t.comparison.title_a} <br />
              <span className="text-pv-teal">{t.comparison.title_b}</span>
            </h2>
            <p className="mt-6 text-slate-600 text-[15.5px] md:text-[17px] leading-[1.65] max-w-xl">
              {t.comparison.lead}
            </p>
          </div>
        )}

        <div className={`${compact ? '' : 'mt-14'} overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_30px_80px_-40px_rgba(15,23,42,0.25)]`}>
          <div className="grid grid-cols-12 bg-slate-50 border-b border-slate-200">
            <div className="col-span-5 md:col-span-6 px-5 md:px-7 py-4 text-[12px] font-mono uppercase tracking-[0.18em] text-slate-500 font-semibold">
              Funzionalità · Feature
            </div>
            <div className="col-span-3 md:col-span-3 px-3 md:px-5 py-4 text-center text-[11.5px] md:text-[12.5px] font-bold text-slate-500 uppercase tracking-wider">
              {t.comparison.headerGeneric}
            </div>
            <div className="col-span-4 md:col-span-3 px-3 md:px-5 py-4 text-center text-[11.5px] md:text-[12.5px] font-bold uppercase tracking-wider relative bg-pv-ice">
              <span className="relative text-pv-teal">{t.comparison.headerPV}</span>
            </div>
          </div>

          {t.comparison.rows.map((r, i) => (
            <div key={i} className={`grid grid-cols-12 ${i % 2 ? 'bg-slate-50/40' : 'bg-white'} border-b border-slate-100 last:border-b-0`}>
              <div className="col-span-5 md:col-span-6 px-5 md:px-7 py-4 md:py-5 text-[14px] md:text-[15px] text-slate-800 font-semibold">
                {r.feature}
              </div>
              <div className="col-span-3 md:col-span-3 flex items-center justify-center">
                {r.generic ? (
                  <span className="w-7 h-7 rounded-full bg-slate-100 flex items-center justify-center">
                    <Check className="w-3.5 h-3.5 text-slate-400" strokeWidth={3} />
                  </span>
                ) : (
                  <span className="w-7 h-7 rounded-full bg-slate-100 flex items-center justify-center">
                    <X className="w-3.5 h-3.5 text-slate-400" strokeWidth={3} />
                  </span>
                )}
              </div>
              <div className="col-span-4 md:col-span-3 flex items-center justify-center relative bg-pv-ice/50">
                <span className="relative w-8 h-8 rounded-full bg-pv-teal flex items-center justify-center shadow-[0_4px_14px_-4px_rgba(27,127,184,0.6)]">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} />
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <SectionActions source="why" items={['demo', 'brochure', 'whatsapp']} />
        </div>
      </div>
    </section>
  );
};

export default Comparison;
